import { Badge, Container, Loader, Paper, SimpleGrid, Text } from "@mantine/core"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { PageHeader } from "@/components/PageHeader"
import { queries } from "@/lib/queries"
import { getStageDisplay } from "@/lib/stages"

const PLAYFAIR = "'Playfair Display', Georgia, serif"

export const Route = createFileRoute("/companies/")({
  component: Companies,
})

function Companies() {
  const navigate = useNavigate()
  const { data, isPending, isError } = useQuery(queries.companies())

  return (
    <Container size="xl">
      <PageHeader eyebrow="Federation">Portfolio Companies</PageHeader>
      {isPending ? (
        <Loader />
      ) : isError ? (
        <Text c="var(--pitch-negative)">Failed to load companies</Text>
      ) : (
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }}>
          {data.map((co) => {
            const stage = getStageDisplay(co.stage)
            return (
              <Paper
                key={co.companyId}
                withBorder
                p="lg"
                radius={0}
                style={{ cursor: "pointer", borderColor: "var(--pitch-border)" }}
                onClick={() => void navigate({ to: `/companies/${co.companyId}` })}
              >
                <Text ff={PLAYFAIR} fz={20} fw={500} c="var(--pitch-text-primary)" style={{ lineHeight: 1.2 }}>
                  {co.name}
                </Text>
                <Text fz={13} c="var(--pitch-text-secondary)" mt={2}>
                  {co.area}
                </Text>
                <Badge size="sm" variant="light" radius="xs" color={stage.color} mt="sm">
                  {stage.label}
                </Badge>
                <Text fz={12} c="var(--pitch-text-tertiary)" mt="xs">
                  Allocation: ${Number(co.allocation).toLocaleString()}
                </Text>
              </Paper>
            )
          })}
        </SimpleGrid>
      )}
    </Container>
  )
}
